import React from 'react';

interface CalculatorData {
  expression?: string;
  result?: string | number;
  explanation?: string;
  error?: string;
}

interface Props {
  data: CalculatorData;
  isDarkMode?: boolean;
}

export const CalculatorCard: React.FC<Props> = ({ data, isDarkMode = false }) => {
  const border = isDarkMode ? 'border-slate-700' : 'border-slate-200';
  const bg = isDarkMode ? 'bg-slate-900/40 text-white' : 'bg-white/70';
  const textMuted = isDarkMode ? 'text-white/70' : 'text-black/70';

  if (data.error) {
    return (
      <div className={`rounded-lg p-3 my-2 border ${border} ${bg}`}>❌ {data.error}</div>
    );
  }

  return (
    <div className={`rounded-2xl bg-transparent`}>
      {data.expression && (
        <div className={`text-xs mb-1 ${textMuted}`}>"{data.expression}"</div>
      )}
      {data.result !== undefined && (
        <div className="text-base font-semibold">{String(data.result)}</div>
      )}
      {data.explanation && (
        <div className={`text-sm mt-1 ${textMuted}`}>{data.explanation}</div>
      )}
    </div>
  );
};

export default CalculatorCard;
